export const SET_PERMISSIOM_DATA = "SET_PERMISSIOM_DATA";
export const RESET_PERMISSION_REDUCER = "RESET_PERMISSION_REDUCER";